import { z } from 'zod/v4';

const publicEnvSchema = z.object({
  NEXT_PUBLIC_SENTRY_DSN: z.string().optional(),
  NEXT_PUBLIC_SENTRY_ENV: z.string().optional().default('local'),

  NEXT_PUBLIC_USE_REACT_QUERY_DEVTOOLS: z.boolean().optional().default(false),
  NEXT_PUBLIC_USE_HOOKFORM_DEVTOOLS: z.boolean().optional().default(false),

  NEXT_PUBLIC_APP_URL: z.string(),

  NEXT_PUBLIC_VERCEL_TARGET_ENV: z.string().optional(),

  NEXT_PUBLIC_SUPPORT_EMAIL: z.email().optional(),

  NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_HOST: z.string().optional(),

  NEXT_PUBLIC_TURNSTILE_SITE_KEY: z.string().optional(),

  NEXT_PUBLIC_STORAGE_URL: z.string(),

  NEXT_PUBLIC_FILES_CDN_URL: z.string().optional(),

  NEXT_PUBLIC_FORECAST_DISABLED_TABS: z.string().optional().default(''),
});

export type PublicEnv = z.infer<typeof publicEnvSchema>;

const publicEnv = publicEnvSchema.parse({
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_SENTRY_ENV: process.env.NEXT_PUBLIC_SENTRY_ENV,

  NEXT_PUBLIC_USE_REACT_QUERY_DEVTOOLS: Boolean(
    process.env.NEXT_PUBLIC_USE_REACT_QUERY_DEVTOOLS,
  ),
  NEXT_PUBLIC_USE_HOOKFORM_DEVTOOLS: Boolean(
    process.env.NEXT_PUBLIC_USE_HOOKFORM_DEVTOOLS,
  ),

  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,

  NEXT_PUBLIC_VERCEL_TARGET_ENV: process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV,

  NEXT_PUBLIC_SUPPORT_EMAIL: process.env.NEXT_PUBLIC_SUPPORT_EMAIL,

  NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,

  NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,

  NEXT_PUBLIC_STORAGE_URL: process.env.NEXT_PUBLIC_STORAGE_URL,

  NEXT_PUBLIC_FILES_CDN_URL: process.env.NEXT_PUBLIC_FILES_CDN_URL,

  NEXT_PUBLIC_FORECAST_DISABLED_TABS: process.env.NEXT_PUBLIC_FORECAST_DISABLED_TABS,
} satisfies Record<keyof PublicEnv, string | boolean | undefined>);

export default publicEnv;
